import { render, staticRenderFns } from "./lklAccount.vue?vue&type=template&id=d5b6c8f6&scoped=true&"
import script from "./lklAccount.vue?vue&type=script&lang=js&"
export * from "./lklAccount.vue?vue&type=script&lang=js&"
import style0 from "./lklAccount.vue?vue&type=style&index=0&id=d5b6c8f6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5b6c8f6",
  null
  
)

export default component.exports